import { isArray } from '@cayuse/shared-react.utils.type-checks';

const isFetching = {};

const startFetching = (dispatch, action) => {
	isFetching[`${action.meta.actionKey}_IS_FETCHING`] = true;
	dispatch({ type: `${action.meta.actionKey}_IS_FETCHING`, isFetching: true, meta: action.meta });
}

const finishFetching = (dispatch, action) => {
	isFetching[`${action.meta.actionKey}_IS_FETCHING`] = false;
	dispatch({ type: `${action.meta.actionKey}_IS_FETCHING`, isFetching: false, meta: action.meta });
}

const isAlreadyFetching = action => isFetching[`${action.meta.actionKey}_IS_FETCHING`];

export const loaderMiddleware = ({ dispatch, getState }) => next => async action => {
	// run logic below only when action type includes "LOADER" string
	if (!action.type.includes("LOADER")) {
		return next(action);
	}

	const { actionKey } = action.meta;
	if (!actionKey) {
		throw new Error("Missing 'actionKey' in 'createLoaderAction' function.");
	}

	if (isAlreadyFetching(action)) {
		console.warn(`Action "${action.meta.actionKey}" already fetching.`);
		return;
	}

	startFetching(dispatch, action);

	const [success, fail] = action.actions;

	try {
		// if pass promise argument is array - use Promise.allSettled to run all promises in parallel
		const response = isArray(action.promise) ? await Promise.allSettled(action.promise) : await action.promise();

		if (success) {
			// callback successful response.
			// note: array of promises won't throw error.
			await success(response, { dispatch, getState });
		}
		finishFetching(dispatch, action);

		return response;

	} catch (error) {
		if (fail) {
			// callback failed response
			await fail(error, { dispatch, getState }, { meta: action.meta });
		}
		finishFetching(dispatch, action);

		if (fail) {
			return null;
		} else {
			throw error;
		}
	}
};
